module.exports = __webpack_public_path__ + "img/canbadge-round-76mm-momo_line.a827fae7.png";